<div class="main-container">

  <div class="title">
    <span class="title-text">Dashboard</span>
    <p class="small-title">Today's check-in and check-out counts. Choose a premises, or view all.</p>
  </div>

  <div class="searchBar">
    <div class="each-div">
      <span class="drop-title">Premises</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="premises" (selectionChange)="loadCounts()">
          <mat-option [value]="'all'">All premises</mat-option>
          @for(item of premisesList; track item.id){
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="btn">
      <button type="button" class="ac-primary-btn" (click)="loadCounts()">Refresh</button>
    </div>
  </div>

  @if(counts){
  <div class="count-cards">
    <div class="count-card">
      <span class="count-label">Checked in today</span>
      <span class="count-value">{{ counts.checkin.done }}</span>
      <span class="count-sub">of {{ counts.checkin.total }} expected</span>
    </div>
    <div class="count-card">
      <span class="count-label">Checked out today</span>
      <span class="count-value">{{ counts.checkout.done }}</span>
      <span class="count-sub">of {{ counts.checkout.total }} expected</span>
    </div>
  </div>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
